import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
const personas = [{
  title: 'Mentes estancadas y saturadas',
  desc: 'Personas que repiten los mismos patrones diarios y se sienten atrapados en una victimización silenciosa.'
}, {
  title: 'Quienes buscan resultados desde casa',
  desc: 'Sin necesidad de terapias interminables, adaptando hábitos básicos y eliminando estímulos tóxicos desde hoy.'
}, {
  title: 'Líderes y profesionales',
  desc: 'Personas bajo mucha presión que necesitan herramientas de choque efectivas para no perder el control de sus decisiones.'
}, {
  title: 'Buscadores de claridad',
  desc: 'Personas decididas a hackear su rutina diaria, recuperar la concentración y el control de su tiempo.'
}];
export function WhoIsThisFor() {
  return <section className="py-24 md:py-32 px-6 bg-cream text-charcoal" data-id="element-202">
      <div className="max-w-5xl mx-auto" data-id="element-203">
        <FadeIn className="text-center mb-16 md:mb-24" data-id="element-204">
          <div className="inline-flex items-center gap-3 mb-6" data-id="element-205">
            <span className="text-3xl" data-id="element-206">🎯</span>
            <h2 className="text-sm tracking-widest uppercase text-terracotta font-semibold" data-id="element-207">
              ¿Para quién es esto?
            </h2>
          </div>
          <h3 className="text-3xl md:text-5xl max-w-3xl mx-auto leading-tight" data-id="element-208">
            Este sistema fue diseñado exclusivamente para personas que quieren
            transicionar del{' '}
            <span className="italic" data-id="element-209">caos a la dirección clara:</span>
          </h3>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-210">
          {personas.map((persona, i) => <StaggerItem key={i} data-id="element-211">
              <div className="h-full p-8 md:p-10 border border-charcoal/10 bg-white/50 hover:bg-white transition-colors duration-300" data-id="element-212">
                <h4 className="text-2xl font-serif mb-4" data-id="element-213">{persona.title}:</h4>
                <p className="text-charcoal/70 text-lg leading-relaxed" data-id="element-214">
                  {persona.desc}
                </p>
              </div>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}